module.exports = __webpack_public_path__ + "static/media/fondo-body.7e5d5c89.jpg";